import { useTheme } from 'antd-style'

import { RichEditorStoreProviderProps } from '../../Store/interface'
import { LINE_HEIGHT_LIST } from '../../Store/store/constants'

export const useStoreConfig = () => {
  const theme = useTheme()

  return {
    defaultFontFamily: '',
    defaultFontSize: theme.fontSizeLG,
    defaultFontColor: theme.colorText,
    defaultFontBackgroundColor: '',
    defaultLineHeight: LINE_HEIGHT_LIST[0].value
  } as RichEditorStoreProviderProps
}
